<template>
  <div class="flex ">
    <input
      type="checkbox"
      @change="handleInput"
      name="Checkbox"
      id="Checkbox"
      :checked="value"
      class=" tw-hidden"
    />
    <label
      for="Checkbox"
      class=" tw-flex tw-group"
      :class="{
        'tw-cursor-pointer': !disabled,
        'tw-pointer-events-none': disabled
      }"
    >
      <div
        class=" tw-h-5 tw-w-5 tw-border tw-border-solid tw-rounded-md tw-mr-2 tw-border-black-100 group-hover:tw-border-primary"
        :class="{
          ' tw-bg-primary-100 tw-border-primary': value && !disabled
        }"
      >
        <icon-done
          v-if="value"
          class=" tw-h-4.5 tw-w-4.5"
          :class="{
            ' tw-fill-black-400': !disabled,
            'tw-fill-black-100': disabled
          }"
        />
      </div>
      <div
        class=" tw-font-semibold tw-text-sm tw-w-full"
        :class="{
          'tw-text-black': !disabled,
          'tw-text-black-100': disabled
        }"
      >
        {{ label }}
      </div>
    </label>
  </div>
</template>

<script>
import IconDone from './icons/IconDone.vue'
export default {
  components: { IconDone },
  name: 'LgkCheckbox',
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: 'Text'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput (event) {
      this.$emit('input', event.target.checked)
      this.$emit('dialogContact', event.target.checked)
    }
  }
}
</script>
